import { ref } from 'vue'

export type AuthenticationFailure = { outcome: string; message: string }
export const protectedActionsPaused = ref(false)
let generation = 0
let failureHandler: ((failure: AuthenticationFailure) => void) | undefined

/** Identifies the visit that issued a request, so ended sessions cannot publish late results. */
export function authenticationGeneration(): number { return generation }

/** Invalidates requests issued before an explicit or remote session end. */
export function endAuthenticationGeneration(): void { generation++ }

/** Connects the API boundary to the single authentication store without an import cycle. */
export function onAuthenticationFailure(handler: (failure: AuthenticationFailure) => void): void {
  failureHandler = handler
}

/** Reports only authentication failures, never ordinary permission denials. */
export function reportAuthenticationFailure(failure: AuthenticationFailure): void {
  failureHandler?.(failure)
}
